module.exports = __webpack_public_path__ + "static/media/text-file-icon.d9653589.png";